import { signal, WritableSignal } from "@angular/core";

import { BaseComponent } from "./base.component";

export abstract class StatefulComponent<ComponentState> extends BaseComponent {

  //#region State Materials
  /** Indicates the current state of the component */
  protected readonly state: WritableSignal<ComponentState | null>;
  //#endregion

  //#region Constructor
  /**
   * Creates a new stateful component instance
   * @param initialState - Optional initial state for the component
   * If not provided, state will be initialized as null
   */
  constructor(initialState?: ComponentState) {
    super();

    // Initialize the state signals.
    this.state = signal<ComponentState | null>(initialState ?? null);
  }
  //#endregion

  //#region State Methods
  /**
   * Sets the component's state to the specified value and resets the status.
   * @param state - The new state value to set
   */
  protected setState(state: ComponentState): void {
    // Do nothing if the state is already set to the new value.
    if (this.state() === state) return;

    // Update the state signal with the new value.
    this.state.set(state);

    // Reset the status when the state changes.
    this.resetStatus();
  }
  //#endregion
}